import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { allReducers } from './reducers';
import Routes from './routes';

// Store
const store = createStore(allReducers);

const rootElement = document.getElementById('root');

const ADMIN_ORIGIN = 'https://adm.expertime.com.ar';

/**
 * Obtiene solamente el origen del sitio que abrió el Timer.
 *
 * Ejemplo:
 * https://adm.expertime.com.ar/eventos/123
 *
 * Devuelve:
 * https://adm.expertime.com.ar
 */
function getReferrerOrigin() {
	try {
		if (!document.referrer) {
			return '';
		}

		return new URL(document.referrer).origin;
	} catch (error) {
		console.error(
			'No se pudo interpretar el referer:',
			error
		);

		return '';
	}
}

/**
 * Renderiza el Timer.
 */
function renderApplication() {
	ReactDOM.render(
		<Provider store={store}>
			<Routes />
		</Provider>,
		rootElement
	);
}

/**
 * Renderiza el mensaje cuando el acceso no está autorizado.
 */
function renderUnauthorized() {
	ReactDOM.render(
		<div
			style={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: '#f5f5f5',
				fontFamily: 'Arial, sans-serif',
				padding: '20px',
				boxSizing: 'border-box'
			}}
		>
			<div
				style={{
					width: '100%',
					maxWidth: '500px',
					padding: '35px',
					backgroundColor: '#ffffff',
					border: '1px solid #dddddd',
					borderRadius: '6px',
					boxShadow:
						'0 2px 8px rgba(0, 0, 0, 0.10)',
					textAlign: 'center'
				}}
			>
				<h2
					style={{
						marginTop: 0,
						color: '#d9534f'
					}}
				>
					NO está autorizado
				</h2>

				<p
					style={{
						fontSize: '16px',
						lineHeight: '1.5',
						color: '#555555'
					}}
				>
					Ingrese al Timer desde el Administrador.
				</p>

				<a
					href="https://adm.expertime.com.ar"
					style={{
						display: 'inline-block',
						marginTop: '15px',
						padding: '10px 18px',
						backgroundColor: '#337ab7',
						color: '#ffffff',
						textDecoration: 'none',
						borderRadius: '4px'
					}}
				>
					Ir al administrador
				</a>
			</div>
		</div>,
		rootElement
	);
}

/**
 * Valida el acceso.
 */
function validateAccess() {
	const referrerOrigin = getReferrerOrigin();

	console.log(
		'Referer completo:',
		document.referrer
	);

	console.log(
		'Origen detectado:',
		referrerOrigin
	);

	/*
	 * Cuando el Timer se abre desde el administrador,
	 * se autoriza esta pestaña.
	 */
	if (referrerOrigin === ADMIN_ORIGIN) {
		sessionStorage.setItem(
			'timer_authorized',
			'true'
		);
	}

	/*
	 * sessionStorage permite recargar la pestaña sin perder
	 * la autorización. Se elimina automáticamente cuando
	 * se cierra la pestaña o el navegador.
	 */
	const isAuthorized =
		sessionStorage.getItem(
			'timer_authorized'
		) === 'true';

	if (isAuthorized) {
		renderApplication();
	} else {
		renderUnauthorized();
	}
}

// Entry
validateAccess();



// WEBPACK FOOTER //
// ./src/index.js